import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import Card from '../../components/CourseCard/Card';
import { getCourseData } from '../../courseData';

const CourseCatalog = () => {
  const params = useParams();
  interface CoursesProps{
    id?: number,
    name?: string,
    description?: string,
    price?: number,
    image?: string,
    categories?:[string]
    instructor:{name: string}
  }

  //adding CoursesProps in generic type causes an error without any
  const [courses, setCourses] = useState<CoursesProps | any>([]);
  useEffect(() => { 
    (async () => setCourses(await getCourseData()))();
  }, []);

  

  return (
    <>
      <div className='ItemDesc'>
        <div>{params.category}</div>
      {courses.map((course: { id: number; name: string; description: string; price: number; image: string; category: string; instructor:{name: string} }) => {
        
        if ( course.category.includes(`${params.category}`)) {
          return (
            <Link to={`/courses/${course.name}`}>
              <Card
                key={course.id}
                name={course.name}
                category={course.category}
                price={course.price}
                image={course.image}
                instructor={course.instructor}
              />
            </Link>
          );
        }

        return null;
        
      })}
    </div><Link to={"/"}>Back to HomePage</Link>
    </>
  )
}

export default CourseCatalog